import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    // Individual
    individualList: [],
    individualListLoading: false,
    current: {},
    currentLoading: false,

    // Team
    teamList: [],
    teamListLoading: false
  },
  mutations: {
    // Individual
    setIndividualList(state, payload) {
      state.individualList = payload;
    },
    setIndividualListLoading(state, payload) {
      state.individualListLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },

    // Team
    setTeamList(state, payload) {
      state.teamList = payload;
    },
    setTeamListLoading(state, payload) {
      state.teamListLoading = payload;
    }
  },
  actions: {
    // Individual
    async loadAllIndividualEntriesForCompetition(
      { commit, rootState },
      competition_id
    ) {
      commit("setIndividualListLoading", true);
      let list = await api.get("events/entries/individualEvents", {
        params: {
          id: competition_id,
          entries: rootState.settings.siteArea == "Entries" ? true : null
        }
      });
      commit("setIndividualList", list.data);
      commit("setIndividualListLoading", false);
    },
    async enterIndividualIntoEvent({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/enterIndividualIntoEvent", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          let response = "There was an error, Please try again later";
          if (
            err.response.data &&
            err.response.data.exception &&
            err.response.data.exception[0].message.includes("Duplicate entry")
          ) {
            response = "This member is already entered for this event.";
          }
          returnData = {
            Result: "Error",
            Response: response
          };
        });
      return returnData;
    },
    async removeIndividualFromEvent({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/removeIndividualFromEvent", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async saveIndividualEntry({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("events/entries/individualEntry", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async confirmAllEntries({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/individualEntry/confirmAll", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },

    // Team
    async loadAllTeamsForEvent({ commit }, payload) {
      commit("setTeamListLoading", true);
      let list = await api.get("events/entries/teamEntries", {
        params: payload
      });
      commit("setTeamList", list.data);
      commit("setTeamListLoading", false);
    },

    async enterTeamIntoEvent({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/enterTeamIntoEvent", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          let response = "There was an error, Please try again later";
          if (
            err.response.data &&
            err.response.data.exception &&
            err.response.data.exception[0].message.includes("Duplicate entry")
          ) {
            response = "This team is already entered for this event.";
          }
          returnData = {
            Result: "Error",
            Response: response
          };
        });
      return returnData;
    },
    async removeTeamFromEvent({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/removeTeamFromEvent", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async removeMemberFromTeam({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/removeMemberFromTeam", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async changeTeamStatus({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("events/entries/changeTeamStatus", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async changeMemberInTeam({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/entries/changeMemberInTeam", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async saveTeamName({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("events/entries/saveTeamName", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async teamMemberSub({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("events/entries/teamMemberSub", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    },
    async teamMemberUnSub({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("events/entries/teamMemberUnSub", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: "There was an error, Please try again later"
          };
        });
      return returnData;
    }
  },
  getters: {
    // Individual
    individualList(state) {
      return state.individualList;
    },
    individualListLoading(state) {
      return state.individualListLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },

    // Team
    teamList(state) {
      return state.teamList;
    },
    teamListLoading(state) {
      return state.teamListLoading;
    }
  }
};
